import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.kiera.resource.users');
import { Input, OnInit, OnChanges } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
const resourceUsersApi = new Wiz('/wiz').app('component.kiera.resource.users');

@Component({
 standalone: false,
 selector: 'wiz-component-kiera-resource-users',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/component.kiera.resource.users/view.scss */
.resource-users {
  background: white;
  padding: 1.25rem;
  border: 1px solid #e4e4e7;
  border-radius: 0.5rem;
  color: #27272a;
}

.resource-heading, .resource-toolbar, .resource-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

h2 {
  font-size: 1rem;
  font-weight: 600;
}

p {
  font-size: 0.8rem;
  margin: 0.5rem 0;
}

.resource-note {
  color: #52525b;
  line-height: 1.65;
}

.resource-error {
  color: #b91c1c;
}

button, input[type=search] {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d4d4d8;
  border-radius: 0.35rem;
  background: white;
  font-size: 0.8rem;
}

button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

label {
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.resource-table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

th, td {
  text-align: left;
  padding: 0.7rem 0.6rem;
  border-bottom: 1px solid #e4e4e7;
}

th {
  background: #fafafa;
  white-space: nowrap;
}

input[type=checkbox] {
  accent-color: #4f46e5;
}

.resource-pagination {
  justify-content: flex-end;
  margin-top: 1rem;
}`],
})
export class ComponentKieraResourceUsersComponent implements OnInit, OnChanges {
    @Input() resourceType: string = 'node';
    @Input() resourceId: number = 0;
    public rows: any[] = [];
    public search: string = '';
    public allowedOnly: boolean = false;
    public page: number = 1;
    public readonly pageSize: number = 25;
    public loading: boolean = false;
    public busy: boolean = false;
    public error: string = '';
    private ready: boolean = false;
    private sequence: number = 0;
    constructor(@Inject( Service) public service: Service) {}
    public t(ko: string, en: string) { return this.service.lang.is('en') ? en : ko; }
    public async ngOnInit() { await this.service.init(); this.ready = true; await this.load(); }
    public async ngOnChanges() { if (this.ready) await this.load(); }
    public async load() {
        if (!this.resourceId) return;
        const sequence = ++this.sequence;
        this.loading = true; this.error = '';
        try {
            const response = await resourceUsersApi.call('load', { resource_type: this.resourceType, resource_id: this.resourceId });
            if (sequence !== this.sequence) return;
            if (response.code !== 200) throw new Error(response.data?.message || this.t('사용자 목록을 불러올 수 없습니다.', 'Could not load resource users.'));
            this.rows = response.data.rows || []; this.page = 1;
        } catch (error: any) { if (sequence === this.sequence) { this.rows = []; this.error = error.message; } }
        finally { if (sequence === this.sequence) { this.loading = false; await this.service.render(); } }
    }
    public filtered() {
        const search = this.search.trim().toLowerCase();
        return this.rows.filter(row => (!this.allowedOnly || row.allowed) && (!search || [row.name, row.email, row.organization_name, row.role].join(' ').toLowerCase().includes(search)))
            .sort((a, b) => Number(b.allowed) - Number(a.allowed) || String(a.name).localeCompare(String(b.name)));
    }
    public visible() { return this.filtered().slice((this.page - 1) * this.pageSize, this.page * this.pageSize); }
    public allowedCount() { return this.rows.filter(row => row.allowed).length; }
    public async toggle(row: any) {
        if (this.busy || row.administrator || row.inherited) return;
        this.busy = true; this.error = '';
        try {
            const response = await resourceUsersApi.call('save', { resource_type: this.resourceType, resource_id: this.resourceId, user_id: row.id, allowed: !row.allowed });
            if (response.code !== 200) throw new Error(response.data?.message || this.t('권한을 변경하지 못했습니다.', 'Could not change resource access.'));
            this.rows = response.data.rows || [];
        } catch (error: any) { this.error = error.message; }
        finally { this.busy = false; await this.service.render(); }
    }
}

export default ComponentKieraResourceUsersComponent;
